import React from 'react';
import { useAppSelector } from '../dal/store';
import Table from './table';
import Error from './error';
const CompareBundles = () => {

    const data = useAppSelector(store => store.root.data);
    const isError = !data || !data.bundles || data.bundles.length <= 0;

    return (
        <>
            <div className="hidden md:block">
                {
                    isError &&
                    <Error />
                }

                {
                    !isError &&
                    <div>
                        <Table />
                    </div>
                }
            </div>

            <div className="md:hidden info-box">
                Compare bundles is available on ipad and desktop.
            </div>
        </>
    )
};

export default CompareBundles;